<script>
import {
  getDate,
  getTime,
  getShortMonth,
  getDayOfWeek,
} from "@/modules/helpers/day";

import { onMounted, ref, toRefs } from "vue";

export default {
  props: {
    poster: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { poster } = toRefs(props);

    const color = ref(null);

    onMounted(async () => {
      const f = await fetch(
        `https://ucarecdn.com/${poster.value.perform.img.fileKey}/-/preview/-/main_colors/`
      );
      const data = await f.json();

      return (color.value = `rgba(${data.main_colors[1].join(",")}, 1)`);
    });

    return {
      getDate,
      getTime,
      getShortMonth,
      getDayOfWeek,
      color,
    };
  },
};
</script>

<template>
  <article class="bg-white rounded-lg relative flex flex-col">
    <header class="overflow-hidden rounded-lg h-72 relative">
      <router-link
        :to="`/buy/${poster.perform._id}/${poster._id}`"
      >
        <img
          class="w-full h-full object-cover"
          :src="`https://ucarecdn.com/${poster.perform.img.fileKey}/-/format/auto/-/quality/smart/image.png`"
          :alt="poster.perform.name"
        />
        <div
          class="
            absolute
            top-3
            right-3
            flex
            transform
            rotate-154
            rounded-lg
            overflow-hidden
            h-10
            w-10
            glass
          "
        ></div>
        <p
          class="text-lg font-semibold absolute top-5 right-3 w-10 text-center"
          :style="`color: ${color}`"
        >
          {{ poster.perform.age_limit }}
        </p>
      </router-link>
    </header>
    <footer class="flex flex-col">
      <div class="grid grid-cols-2 h-auto p-4">
        <div class="flex flex-col space-y-4">
          <h6
            class="
              font-sans
              text-primary text-sm
              sm:text-base
              lowercase
              mt-2
              lg:mt-0
              sm:mt-2
              xl:mt-2
            "
          >
            {{
              `${getDate(poster.date)} ${getShortMonth(poster.date)} ${getTime(
                poster.date
              )}, ${getDayOfWeek(poster.date)}`
            }}
          </h6>
        </div>
        <div class="flex flex-row">
          <nuxt-link
            class="ml-auto justify-self-end"
            :to="`/buy/${poster.perform._id}/${poster._id}`"
          >
            <button
              :disabled="!poster.isActive"
              class="
                text-center text-sm
                transition
                bg-primary
                duration-300
                ease-out
                rounded-md
                font-semibold
                leading-none
                focus:outline-none
                py-10p
                px-5
                text-white
              "
              :class="[
                poster.isActive
                  ? 'hover:bg-cherry cursor-pointer'
                  : 'bg-opacity-20 cursor-default',
              ]"
            >
              {{ poster.isActive ? "Купить билет" : "Билеты проданы" }}
            </button>
          </nuxt-link>
        </div>
      </div>

      <div class="p-4 pt-0">
        <h3 class="font-sans text-dark-gray text-lg2">
          <router-link :to="`/theater/performs/${poster.perform._id}`">
            {{ poster.perform.name }}
          </router-link>
        </h3>
      </div>
    </footer>
  </article>
</template>

<style lang="scss" scoped>
.glass {
  backdrop-filter: blur(30px) brightness(1.15) opacity(1);
}
</style>
